export const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
export const integerRegex = /^\d*$/;
